import React from "react";
import { Helmet } from "react-helmet-async";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../styles/beneficio-pilates.min.css';
import Img1 from '../assets/pilates-image-bebeficio-top.png';
const Slider = React.lazy(() => import("react-slick"));


export default function Beneficios() {
    const multipleitems = {
        infinite: true,
        slidesToShow: 1,
        dots: true,
        arrow: false,
        autoplay: true,
        autoplaySpeed: 8000,
        slidesToScroll: 1
    };

  return (
    
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/beneficios" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma." />
        </Helmet>
    
        <main className='beneficio-pilates'>
            <section className="pilates-beneficio-top">
                <h1>Benefícios do <span>Pilates</span></h1>

                <div className="pilates-beneficio-top-img">
                    <img src={Img1} alt="Pilates Centro Criciúma OsteoVitta"/>
                </div>
            </section>

            <section className="pilates-benefico-descricao-titulo">
                <h2>Pilates - Benefícios à saúde</h2>
            </section>

            <section className="pilates-advantage multiple-items">
                <Slider {...multipleitems} className="sliderBanner">
                    <div>
                        <ul className="pilates-advantage-list">

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_01">reduza o estresse</h2>
                                    <span className="pilates-advantage-subTitle">do dia a dia</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Desenvolva o autocontrole por meio da respiração e do movimento consciente, e aprenda a lidar melhor com situações de estresse, ansiedade e tensão.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_02">Alivia dores</h2>
                                    <span className="pilates-advantage-subTitle">do corpo</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Recomendado por especialistas, o Pilates é eficaz no tratamento de dores crônicas, especialmente na coluna e nas articulações, promovendo alívio e mais qualidade de vida.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_03">Fortalece a musculatura</h2>
                                    <span className="pilates-advantage-subTitle">profunda e superficial</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    O Pilates ativa e fortalece todo o corpo, com foco especial nos músculos profundos, 
                                    essenciais para postura, estabilidade e equilíbrio.
                                </span>
                            </li>

                        </ul>
                    </div>    

                    <div>
                        <ul className="pilates-advantage-list">
                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_04">Melhora a respiração </h2>
                                    <span className="pilates-advantage-subTitle">e a capacidade pulmonar</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    O Pilates estimula a musculatura respiratória e ensina a respirar de forma consciente e eficiente, 
                                    aumentando a oxigenação e o controle da respiração.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_05">Corrige a postura</h2>
                                    <span className="pilates-advantage-subTitle">e aumenta a flexibilidade</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Com foco no alinhamento corporal e na mobilidade, o Pilates melhora a postura, previne lesões e 
                                    contribui para um corpo mais jovem e funcional ao longo do tempo.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_06">Melhora A CONCENTRAÇÃO</h2>
                                    <span className="pilates-advantage-subTitle">atenção e foco</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Com movimentos precisos e controlados, o Pilates estimula a conexão entre corpo e mente, 
                                    ajudando você a manter o foco e a concentração, sem se distrair com estímulos externos ou internos.
                                </span>
                            </li>
                        </ul>
                    </div>
                </Slider>
            </section>

            <section className="pilates-advantage pilates-advantage-desktop">
                    <ul className="pilates-advantage-list">

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_01">reduza o estresse</h2>
                                <span className="pilates-advantage-subTitle">do dia a dia</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Desenvolva o autocontrole por meio da respiração e do movimento consciente, 
                                e aprenda a lidar melhor com situações de estresse, ansiedade e tensão.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_02">Alivia dores</h2>
                                <span className="pilates-advantage-subTitle">do corpo</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Recomendado por especialistas, o Pilates é eficaz no tratamento de dores crônicas, 
                                especialmente na coluna e nas articulações, promovendo alívio e mais qualidade de vida.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_03">Fortalece a musculatura</h2>
                                <span className="pilates-advantage-subTitle">profunda e superficial</span>
                            </div>
                            <span className="pilates-advantage-text">
                                O Pilates ativa e fortalece todo o corpo, com foco especial nos músculos profundos, 
                                essenciais para postura, estabilidade e equilíbrio.
                            </span>
                        </li>

                    </ul>

                    <ul className="pilates-advantage-list">
                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_04">Melhora a respiração</h2>
                                <span className="pilates-advantage-subTitle">e a capacidade pulmonar</span>
                            </div>
                            <span className="pilates-advantage-text">
                                O Pilates estimula a musculatura respiratória e ensina a respirar de forma consciente e eficiente, 
                                aumentando a oxigenação e o controle da respiração.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_05">Corrige a postura</h2>
                                <span className="pilates-advantage-subTitle">e aumenta a flexibilidade</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Com foco no alinhamento corporal e na mobilidade, o Pilates melhora a postura, 
                                previne lesões e contribui para um corpo mais jovem e funcional ao longo do tempo.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_06">Melhora A CONCENTRAÇÃO</h2>
                                <span className="pilates-advantage-subTitle">atenção e foco</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Com movimentos precisos e controlados, o Pilates estimula a conexão entre corpo e mente, 
                                ajudando você a manter o foco e a concentração, sem se distrair com estímulos externos ou internos.
                            </span>
                        </li>

                    </ul>
            </section>

            <section className="pilates-advantage pilates-advantage-tablet">
                <ul className="pilates-advantage-list">

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_01">reduza o estresse</h2>
                            <span className="pilates-advantage-subTitle">do dia a dia</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Desenvolva o autocontrole por meio da respiração e do movimento consciente, 
                            e aprenda a lidar melhor com situações de estresse, ansiedade e tensão.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_02">Alivia dores</h2>
                            <span className="pilates-advantage-subTitle">do corpo</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Recomendado por especialistas, o Pilates é eficaz no tratamento de dores crônicas, 
                            especialmente na coluna e nas articulações, promovendo alívio e mais qualidade de vida.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_03">Fortalece a musculatura</h2>
                            <span className="pilates-advantage-subTitle">profunda e superficial</span>
                        </div>
                        <span className="pilates-advantage-text">
                            O Pilates ativa e fortalece todo o corpo, com foco especial nos músculos profundos, 
                            essenciais para postura, estabilidade e equilíbrio.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_04">Melhora a respiração</h2>
                            <span className="pilates-advantage-subTitle">e a capacidade pulmonar</span>
                        </div>
                        <span className="pilates-advantage-text">
                            O Pilates estimula a musculatura respiratória e ensina a respirar de forma consciente e eficiente, 
                            aumentando a oxigenação e o controle da respiração.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_05">Corrige a postura</h2>
                            <span className="pilates-advantage-subTitle">e aumenta a flexibilidade</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Com foco no alinhamento corporal e na mobilidade, o Pilates melhora a postura, 
                            previne lesões e contribui para um corpo mais jovem e funcional ao longo do tempo.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_06">Melhora A CONCENTRAÇÃO</h2>
                            <span className="pilates-advantage-subTitle">atenção e foco</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Com movimentos precisos e controlados, o Pilates estimula a conexão entre corpo e mente, 
                            ajudando você a manter o foco e a concentração, sem se distrair com estímulos externos ou internos.
                        </span>
                    </li>

                </ul>
            </section>


            <section style={{marginTop: "60px"}}  className="pilates-benefico-descricao">
                <p className="pilates-benefico-descricao-text">
                    Praticar Pilates pode ser considerado um dos melhores exercícios para quem deseja aperfeiçoar a musculatura
                    corporal, evitar doenças cardiovasculares, eliminar o estresse ocasionado pela correria do dia a dia,
                    emagrecer, corrigir a postura, aumentar a flexibilidade, estimular a coordenação motora, prevenir fraturas
                    ocasionadas pela osteoporose, melhorar concentração e amenizar dores. Enfim, uma infinidade de benefícios
                    que, certamente, auxiliarão seu corpo e sua mente.
                    <br/><br/>
                    A prática de Pilates pode ser feita por qualquer pessoa de 08 a 80 anos, desde que acompanhado por
                    profissionais responsáveis.
                    <br/><br/>
                    O Pilates influencia no aperfeiçoamento do individuo em três segmentos:
                    <br/><br/>

                    <span className="pilates-benefico-descricao-text--bold">
                        1 - Corpo são e mais resistência com exercícios de
                        Pilates
                    </span>

                    <br/><br/>
                    Quem pratica Pilates com frequência percebe as seguintes melhorias no copo: Postura, mobilidade e
                    flexibilidade da espinha, melhor distribuição do tônus muscular, fortalecimento do abdômen, estabilidade
                    para a pélvis e ombros, conquista da saúde das articulações e complemento do treino para atletas.
                    Ou seja, Pilates é mais do que uma série de exercícios, é uma filosofia de vida para aqueles que desejam
                    inibir os resultados que o tempo proporciona ao corpo.
                    <br/><br/>
                    O crescimento muscular para os praticantes do Pilates pode ocorrer de duas maneiras: Uma é quando a região
                    está passando por alongamento máximo (esticar o membro). Outra é quando ocorre a hipertrofia muscular,
                    aumento da área de comprimento muscular, quando o individuo sente o músculo “queimar” no momento da
                    contração.
                    <br/><br/>

                    <span className="pilates-benefico-descricao-text--bold">2 - Exercícios de Pilates fazem bem à saúde</span>
                    <br/><br/>
                    O Pilates é essencial para a melhoria da saúde. Ele facilita a prevenção de doenças e a reabilitação física,
                    auxilia no desenvolvimento do equilibro e coordenação, especialmente para os idosos. Oferece uma forma de
                    exercício excelente e segura para mulheres grávidas, além de contribuir para a recuperação do corpo após o
                    parto.
                    <br/><br/>
                    Ao praticar Pilates o indivíduo sente um alivio quanto a possíveis dores no corpo. Além disso, ele melhora a
                    densidade óssea, desenvolve a função e eficiência pulmonar com a melhora da circulação. Um ponto crucial é:
                    o Pilates também ajuda no tratamento de doenças como escoliose, osteoporose, artrite e esclerose múltipla.
                    <br/><br/>
                    Além de todos os temas citados, o Pilates também ajuda no desenvolvimento sexual graças aos exercícios com
                    músculos pélvicos e a ajuda na questão da sensibilidade corporal. O Pilates também influencia à memória com
                    exercícios de coordenação.
                    <br/><br/>
                    Bom também para a pele, graças a melhoria da circulação. Pele mais radiante e corpo em perfeito estado
                    satisfação.
                    <br/><br/>

                    <span className="pilates-benefico-descricao-text--bold">3 - Bem Estar com Pilates</span>

                    <br/><br/>
                    Diante de todos os benefícios citados acima é fácil entender que o Pilates ajuda e muito na sua maneira de
                    enxergar e viver no mundo. Ele faz você parecer e se sentir melhor, ajuda a aumentar a qualidade do seu
                    sono, alivia o estresse e a tensão, expande a consciência corporal, integra o corpo, a mente e o espírito e
                    melhora, muito, a qualidade de vida.
                    <br/><br/>
                    São muitos os benefícios e é impossível listar todos, pois cada corpo responde de uma maneira diferente.
                    Matricule-se, aprenda sobre o seu corpo e saiba entender as respostas que ele dá.
                </p>
            </section>

            <section className="pilates-beneficio-citacao">
                <p>
                    "Boa forma física é o primeiro requisito de felicidade. De maneira a alcançarmos esta felicidade, é
                    fundamental ganhar o domínio de seu corpo. Se você está com 30 anos e está rígido e fora de forma, você está
                    velho. Se você está com 60 e está maleável e forte, você está novo." – Joseph Pilates
                </p>
            </section>

        </main>
    </>
  );
}